import type { ActionTree, MutationTree } from 'vuex';
import { ONBOARDING_TOOLTIPS } from '~/components/common/constants';
import type { RootState } from '~/types/store';

type UiState = {
  avatarUrl: string | null;
  isOnboardingNextDisabled: boolean;
  isCommissionDropdownOpen: boolean;
  isSuperInviteDropdownOpen: boolean;
  isReferralTooltipOpen: boolean;
  onboardingTooltips: Record<string, boolean>;
  isNotificationsDropdownOpen: boolean;
};

export const state: () => UiState = () => {
  return {
    avatarUrl: null,
    isOnboardingNextDisabled: false,
    isCommissionDropdownOpen: false,
    isSuperInviteDropdownOpen: false,
    isReferralTooltipOpen: false,
    onboardingTooltips: ONBOARDING_TOOLTIPS.reduce((hash, tooltip) => {
      hash[tooltip] = false;
      return hash;
    }, {} as Record<string, boolean>),
    isNotificationsDropdownOpen: false,
  };
};

export const mutations: MutationTree<UiState> = {
  setAvatarUrl(state, avatarUrl: string) {
    state.avatarUrl = avatarUrl;
  },
  // @DEPRECATED
  // toggleOnboardingNext(state, isDisabled = false) {
  //   state.isOnboardingNextDisabled = isDisabled;
  // },
  // toggleCommissionDropdown(state, isOpen) {
  //   state.isCommissionDropdownOpen = isOpen;
  // },
  toggleSuperInviteDropdown(state, isOpen: boolean) {
    state.isSuperInviteDropdownOpen = isOpen;
  },
  showOnboardingTooltip(state, tooltipName: string) {
    state.onboardingTooltips = ONBOARDING_TOOLTIPS.reduce((hash, tooltip) => {
      hash[tooltip] = tooltip === tooltipName;
      return hash;
    }, {} as Record<string, boolean>);
  },
  closeOnboardingTooltip(state, tooltipName: string) {
    state.onboardingTooltips[tooltipName] = false;
  },
  toggleNotificationsDropdown(state, isOpen: boolean) {
    state.isNotificationsDropdownOpen = isOpen;
  },
  toggleReferralTooltip(state, isOpen: boolean) {
    state.isReferralTooltipOpen = isOpen;
  },
};

export const actions: ActionTree<UiState, RootState> = {
  showNextOnboardingTooltip({ commit, rootState }) {
    if (rootState.auth.loggedIn) {
      const onboardingTooltipsSequence = [...ONBOARDING_TOOLTIPS];

      while (onboardingTooltipsSequence.length) {
        const nextTooltip = onboardingTooltipsSequence.pop();

        // we can't use this.$tooltip.isPresent here as this.$tooltip is undefined inside store plugins
        // see store/index.ts
        if (!rootState.auth.user.tooltips?.includes(nextTooltip as string)) {
          commit('showOnboardingTooltip', nextTooltip);
          break;
        }
      }
    }
  },
};
